import React, {Component} from "react";
import MapaLibres from "../Mapas/MapaLibres";
//import GoogleMaps from "simple-react-google-maps";



    const MapasLugaresLibres = ({freePlaces}) => {
    //console.log(myMarkers.extra.comercios[1]);
    var mapsItems = freePlaces.extra.sensors.map( function(item) {
      return ({ lat: Number(item.latitud), lng: Number(item.longitud), title: item.nombre })
    });
    console.log("freePlaces");
    console.log(freePlaces)
    

    
    return (
      <div >
        <MapaLibres freePlaces={freePlaces}/>
      </div>
    )
        }

export default MapasLugaresLibres;